import { FederalAgeCategory } from "../enums/index.js";

/**
 * Calcule la catégorie d'âge FFPJP d'un joueur.
 * Convention FFPJP : référence = 1er janvier de l'année en cours.
 *
 * Tranches (âge au 1er janvier de l'année) :
 * - BENJAMIN  : < 11 ans
 * - MINIME    : 11–13 ans
 * - CADET     : 14–17 ans
 * - JUNIOR    : 18–21 ans
 * - SENIOR    : 22–59 ans
 * - VETERAN   : >= 60 ans
 */
export function computeAgeCategory(
  birthDate: Date,
  referenceDate?: Date,
): FederalAgeCategory {
  const ref = referenceDate ?? new Date(new Date().getFullYear(), 0, 1);
  const age = ref.getFullYear() - new Date(birthDate).getFullYear();

  if (age < 11) return FederalAgeCategory.BENJAMIN;
  if (age <= 13) return FederalAgeCategory.MINIME;
  if (age <= 17) return FederalAgeCategory.CADET;
  if (age <= 21) return FederalAgeCategory.JUNIOR;
  if (age <= 59) return FederalAgeCategory.SENIOR;
  return FederalAgeCategory.VETERAN;
}
